import { render } from "./EditPriceDrops.vue?vue&type=template&id=3a9e95ca&scoped=true"
import script from "./EditPriceDrops.vue?vue&type=script&lang=js"
export * from "./EditPriceDrops.vue?vue&type=script&lang=js"

import "./EditPriceDrops.vue?vue&type=style&index=0&id=3a9e95ca&lang=scss&scoped=true"
import "./EditPriceDrops.vue?vue&type=style&index=1&id=3a9e95ca&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a9e95ca"]])

export default __exports__